"use client";
import React from 'react';
import { ReportFilterType } from '../types';
import { Select, FormGroup, MultipleSelect } from '@develos/next-components';
import { useTranslations } from '@develos/next-library';
import { monthsOptions, weekDaysOptions, yearOptions } from '../constants';

type Props = {
  filters: ReportFilterType,
  setFilters: React.Dispatch<React.SetStateAction<ReportFilterType>>,
}

const ReportConfigContainer = ({filters, setFilters}: Props) => {
  const { translate } = useTranslations();
  return (
    <>
      <div className="rm-relative md:rm-col-span-6 xl:rm-col-span-3">  
        <FormGroup label={translate('Miesiąc')}>
          <Select
            options={monthsOptions}
            value={filters.selectedMonth as number}
            handleChange={(e, value) => setFilters({
              ...filters, 
              selectedMonth: value as number
            })} 
          />
        </FormGroup>
      </div>
      <div className="rm-relative md:rm-col-span-6 xl:rm-col-span-3">  
        <FormGroup label={translate('Rok')}>
          <Select
            options={yearOptions()}
            value={filters.selectedYear as number}
            handleChange={(e, value) => setFilters({
              ...filters, 
              selectedYear: value as number
            })} 
          />
        </FormGroup>
      </div>
      <div className="rm-relative md:rm-col-span-6 xl:rm-col-span-3">  
        <FormGroup label={translate('Dni tygodnia')}>
          <MultipleSelect
            options={weekDaysOptions}
            value={filters.selectedWeekDays}
            handleChange={(e, value) => setFilters({
              ...filters, 
              selectedWeekDays: value as string[]
            })} 
          />
        </FormGroup>
      </div>
    </>
  );
};

export default ReportConfigContainer;